import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent } from "vue";
import { mapActions, mapState, mapWritableState } from "pinia";
//@ts-ignore
import { deepCopy } from "@utils/ObjectUtils";
import { usePlaceType } from "@wkComposables/usePlaceType";
//@ts-ignore
import { usePlaceName } from "@wkComposables/usePlaceName";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
//@ts-ignore
import { getDistrictsByZoneId, getPlace, getZones } from "@services/placesAPI";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
//@ts-ignore
import { getPlacesAddressAutocomplete } from "@services/geographyAPI";
//@ts-ignore
import { getPlaceFromGAutocomplete } from "@utils/GAutocompleteUtils";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { DrawIcon } from "@vueEntry/SvgIcons/DrawIcon";
//@ts-ignore
import { PinIcon } from "@vueEntry/SvgIcons/PinIcon";
//@ts-ignore
import { SearchIcon } from "@vueEntry/SvgIcons/SearchIcon";
//@ts-ignore
import StaticSpinner from "@vueEntry/StaticSpinner.vue";
//@ts-ignore
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import RadioButton from "@vueEntry/UIKitComponents/Radio/RadioButton.vue";
import { useSearchBeanStore } from "@store/SearchBeanStore";
import { useHomeTabStore } from "@wkWebSrc/js/store";
import { TABTYPE } from "@customTypes/HomeTabTypeEnum";
import { useValuationPlaceStore } from "@store/ValuationPlaceStore";
import BaseAccordionItem from "@vueEntry/UIKitComponents/Accordion/BaseAccordionItem.vue";
export default defineComponent({
  name: "PlaceBox",
  components: {
    StaticSpinner,
    RadioButton,
    BaseInput,
    BaseAutocomplete,
    BaseButton,
    CheckboxBtn,
    DrawIcon,
    PinIcon,
    SearchIcon,
    BaseAccordionItem
  },
  props: {
    customListingTypologyURL: {
      type: String,
      default: ""
    },
    useContractType: {
      type: Boolean,
      default: true
    },
    agencyFilter: {
      type: Object,
      default: null
    },
    hasError: {
      type: Boolean
    },
    listing: {
      type: Boolean
    },
    freesearch: {
      type: Boolean
    },
    freesearchDefault: {
      type: String
    },
    place: {
      type: Object
    },
    showPlaceMapDropDown: {
      type: Boolean,
      default: true
    },
    dropDownMenuActive: {
      type: Boolean,
      default: false
    },
    closeDropDown: {
      type: Boolean,
      default: false
    },
    isAgency: {
      type: Boolean
    }
  },
  emits: ["focus-in", "hide-place-modal", "show-map", "new-place", "emit-place"],
  setup() {
    var {
      localityList,
      zoneList,
      searchBeanModal,
      localitySelected,
      zoneIDsSelected,
      zoneModifiedByUser,
      districtSelected,
      districtsObj,
      //Methods
      convertEnergyClassFilter,
      convertFloor,
      resetSearchBeanZonesAndLocalities,
      updateSearchModal,
      updateSearchModalAndPlace,
      fixSearchBean,
      initZonesAndLocalities,
      areAllDistrictsSelected,
      isZoneOrLocalitySelected,
      areZonesAndLocalitiesEmpty,
      areZonesAndLocalitiesFilled,
      getSingleSelectedDistrict,
      getZoneById,
      resetZoneAndLocalities,
      isZoneSelected,
      isLocationSelected,
      isDistrictSelected,
      insertDistrictByZoneId,
      onPlaceLIClick,
      onDistrictClick
    } = usePlaceType();
    var {
      currentPlaceName,
      //Refs
      locationLabel,
      zonesLabel,
      //Computed
      //Methods
      updateLocationName,
      updateZoneName,
      updateSingleDistrictName,
      updateGenericPlaceName,
      updateCityName
    } = usePlaceName();
    var {
      search
    } = useSearch();
    return {
      //Refs
      currentPlaceName,
      //Computed
      locationLabel,
      zonesLabel,
      //Methods
      updateLocationName,
      updateZoneName,
      updateSingleDistrictName,
      updateGenericPlaceName,
      updateCityName,
      //usePlaceType
      localityList,
      zoneList,
      searchBeanModal,
      localitySelected,
      zoneIDsSelected,
      zoneModifiedByUser,
      districtSelected,
      districtsObj,
      //Methods
      convertEnergyClassFilter,
      convertFloor,
      resetSearchBeanZonesAndLocalities,
      updateSearchModal,
      updateSearchModalAndPlace,
      fixSearchBean,
      initZonesAndLocalities,
      areAllDistrictsSelected,
      isZoneOrLocalitySelected,
      areZonesAndLocalitiesEmpty,
      areZonesAndLocalitiesFilled,
      getSingleSelectedDistrict,
      getZoneById,
      resetZoneAndLocalities,
      isZoneSelected,
      isLocationSelected,
      isDistrictSelected,
      insertDistrictByZoneId,
      onPlaceLIClick,
      onDistrictClick,
      //useSearch
      search
    };
  },
  data() {
    return {
      disableCb: true,
      valuationAddress: undefined,
      autocompleteValue: undefined,
      freesearchValue: "",
      placeTest: null,
      showMapModal: false,
      mapPlace: null,
      aroundMe: false,
      showZoneModal: false,
      tempPlace: null,
      publicValuation: {
        realEstateValuation: {
          address: "",
          sqM: null,
          rooms: null,
          typologyID: 0
        },
        privateValuation: true,
        contactDesired: null,
        email: "",
        name: "",
        surname: "",
        phone: null
      },
      dropDownMenu: false,
      spinnerIcon: false,
      isSelectionValid: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({
    TABTYPE() {
      return TABTYPE;
    },
    placeholder() {
      return this.isAgency ? "Inserisci luogo" : this.labels.insertSearchCity;
    },
    labels() {
      return window["_labels"];
    },
    containerClasses() {
      if (!this.listing || this.freesearch) return "";
      return this.showZoneModal || this.dropDownMenu ? "" : "";
    },
    isSearchReady() {
      return !(!this.searchBean.cityURL && !this.searchBean.polygonFromMap);
    },
    localitiesLabel() {
      return this.labels.localities;
    },
    cdn() {
      return window["_cdn"];
    },
    hasValuationAddress() {
      var _a;
      return !!((_a = this.tempPlace) === null || _a === void 0 ? void 0 : _a.address);
    },
    openDropdownMenu() {
      var _a;
      return !((_a = this.autocompleteValue) === null || _a === void 0 ? void 0 : _a.label) || this.isSelectionValid && !this.showZoneModal;
    }
  }, mapState(useSearchBeanStore, ["searchBean"])), mapState(useHomeTabStore, ["activeTab"])), mapState(useHomeTabStore, {
    valuation: store => store.isTabActive(TABTYPE.VALUATE),
    selling: store => store.isTabActive(TABTYPE.SELLING),
    isTrendPage: store => store.isTabActive(TABTYPE.TREND)
  })), mapWritableState(useValuationPlaceStore, ["valuationAddressLoading", "valuationPlace"])),
  watch: {
    showZoneModal(cur, prev) {
      this.disableCb = cur;
    },
    currentPlaceName(cur, prev) {
      this.autocompleteValue = {
        label: cur
      };
      this.isSelectionValid = true;
    },
    searchBean: {
      handler(cur, prev) {
        if (cur.polygonFromMap) {
          this.zoneList = [];
          this.zoneIDsSelected = [];
          this.localityList = [];
          this.localitySelected = undefined;
          this.showZoneModal = false;
          this.zoneModifiedByUser = false;
          this.districtsObj = {};
          this.districtSelected = {};
        }
        if (!this.searchBean.polygonFromMap && !this.searchBean.cityDisplayName && !this.searchBean.cityURL && !this.searchBean.cityName) this.currentPlaceName = "";
        //this is because mapModal emit the place to the searchboxhome and the only way to know that the placename need to be update is to watch it
        else if (this.searchBean.polygonFromMap) this.updatePlaceName();
        // else
        //     this.updatePlaceName();
      },
      deep: true
    },
    closeDropDown: {
      handler(cur, prev) {
        this.dropDownMenu = !cur;
        this.showZoneModal = !cur;
      }
    }
  },
  created() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
      this.updateSearchModal(JSON.parse(JSON.stringify(this.searchBean)));
      this.convertEnergyClassFilter();
      this.convertFloor();
      this.freesearchValue = (_a = this.freesearchDefault) !== null && _a !== void 0 ? _a : "";
      this.dropDownMenu = this.dropDownMenuActive;
      //This listener will be used to close the zone modal whenever the user click outside the zones/localities dropdown
      document.body.addEventListener("click", event => {
        var clickedItem = event.target;
        if (this.showZoneModal) {
          this.showZoneModal = false;
        }
        if (this.dropDownMenu && !clickedItem.className.includes("exclude-event-target")) {
          this.dropDownMenu = false;
        }
      });
      if (this.place) this.placeTest = deepCopy(this.place);
      var {
        zoneIdList,
        localityIdList,
        cityId
      } = this.searchBeanModal;
      //Just one zone
      if (((_b = this.placeTest) === null || _b === void 0 ? void 0 : _b.zoneID) && !this.placeTest.districtID) this.zoneIDsSelected = [this.placeTest.zoneID];else if (zoneIdList && zoneIdList.length > 0 && ((_c = this.placeTest) === null || _c === void 0 ? void 0 : _c.placeType) !== "D") {
        this.zoneIDsSelected = zoneIdList;
      } else if (((_d = this.placeTest) === null || _d === void 0 ? void 0 : _d.placeType) === PLACE_TYPE.DISTRICT) {
        this.searchBeanModal.zoneId = null;
        this.searchBeanModal.zoneIdList = [];
        this.zoneIDsSelected = [];
      }
      if (cityId) {
        yield this.initZonesAndLocalities(getZones(cityId));
        if (!localityIdList) return;
        this.localitySelected = this.localityList.find(l => l.localityID === localityIdList[0]);
      }
      this.updatePlaceName();
    });
  },
  methods: Object.assign({
    initSingleDistrict(zoneId, districtId) {
      return __awaiter(this, void 0, void 0, function* () {
        var districts = yield getDistrictsByZoneId(zoneId);
        var singleDistrict = districts.find(d => d.districtID === districtId);
        this.districtsObj[singleDistrict === null || singleDistrict === void 0 ? void 0 : singleDistrict.zoneID] = [singleDistrict];
        //Adding the district to the district object
        this.insertDistrictByZoneId(zoneId, districtId);
      });
    },
    onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!query) return;
        var res = yield getPlacesAddressAutocomplete(query, 10);
        return res.map(r => ({
          label: r.description,
          id: r.place_id
        }));
      });
    },
    optionSelectedCb(selectedEl) {
      return __awaiter(this, void 0, void 0, function* () {
        this.disableCb = true;
        this.valuationAddressLoading = true;
        var {
          place
        } = yield getPlaceFromGAutocomplete("".concat(selectedEl.id), selectedEl.label);
        this.valuationAddressLoading = false;
        this.tempPlace = place;
        this.confirmPlace();
      });
    },
    handleClick() {
      this.$refs.placeAutocomplete.select();
      this.disableCb = false;
      /* We won't show the dropdown to open the map in valuation or selling mode */
      if (this.valuation || this.selling) return;
      /* Showing the dropdown when there is no text in place autocomplete */
      if (this.openDropdownMenu) this.dropDownMenu = true;
    },
    managePlace(selectedPlace) {
      if (!selectedPlace) return;
      this.disableCb = true;
      this.resetSearchBeanZonesAndLocalities();
      var updatePlaceCb = () => {
        this.placeTest = Object.assign({}, selectedPlace);
        this.confirmPlace();
      };
      if (selectedPlace.placeType == PLACE_TYPE.CITY) {
        this.updateSearchModalAndPlace(selectedPlace, () => {
          this.placeTest = Object.assign({}, selectedPlace);
        });
        if (!this.isTrendPage) {
          this.emitPlace();
          this.updatePlaceName();
          this.initZonesAndLocalities(getZones(selectedPlace.cityID), () => {
            this.openZoneModal();
          },
          //that means there are no zones
          () => {
            this.updateSearchModalAndPlace(selectedPlace, updatePlaceCb);
          });
        } else {
          this.confirmPlace();
          this.updatePlaceName();
        }
      } else if (selectedPlace.placeType == PLACE_TYPE.DISTRICT) {
        this.initSingleDistrict(selectedPlace.zoneID, selectedPlace.districtID).then(() => {
          this.updateSearchModalAndPlace(selectedPlace, updatePlaceCb);
        });
      } else
        //e.g. if the selected
        //option is a province...
        this.updateSearchModalAndPlace(selectedPlace, updatePlaceCb);
    },
    openDropDown(e) {
      e.stopPropagation();
      this.dropDownMenu = true;
    },
    fromDropDownToZoneModal() {
      this.dropDownMenu = false;
      if (this.isTrendPage) this.confirmPlace();
      var hasAnyZonesOrLocalities = this.zoneList.length + this.localityList.length;
      if (hasAnyZonesOrLocalities) this.showZoneModal = true;
    },
    updatePlaceNameAndEmit() {
      this.updatePlaceName();
      this.emitPlace();
    },
    updatePlaceName() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      /* LOCALITY */
      if (this.localitySelected || ((_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.localityID) && !this.zoneIDsSelected.length) {
        this.updateLocationName((_b = this.localitySelected) !== null && _b !== void 0 ? _b : this.placeTest);
        return;
      }
      /* DRAWN AREA MAP */
      // eslint-disable-next-line max-len
      if (this.listing && !!this.searchBeanModal.polygonFromMap && this.searchBeanModal.placeType != "I" || !this.listing && !!this.searchBean.polygonFromMap && this.searchBean.placeType != "I") {
        this.currentPlaceName = this.labels.mapAreaDrawn;
      }
      /* VACATION PLACE LIKE CINQUE TERRE */else if (!!this.searchBean.polygonFromMap && this.searchBean.placeType == "I") {
        this.currentPlaceName = (_c = this.searchBean) === null || _c === void 0 ? void 0 : _c.cityDisplayName;
      } else if (this.searchBeanModal.placeType == PLACE_TYPE.AREA) {
        this.updateGenericPlaceName(this.placeTest);
      } else {
        //Zones and district greater than one
        if (this.zoneIDsSelected.length >= 0 || ((_d = this.searchBeanModal.districtIdList) === null || _d === void 0 ? void 0 : _d.length) >= 0) {
          if ([PLACE_TYPE.PROVINCE, PLACE_TYPE.AREA_OF_INTEREST, PLACE_TYPE.REGION, PLACE_TYPE.LOCALITY].includes(((_e = this.placeTest) === null || _e === void 0 ? void 0 : _e.placeType) || "")) this.updateGenericPlaceName(this.placeTest);
          // eslint-disable-next-line max-len
          else if (!((_f = this.searchBeanModal.districtIdList) === null || _f === void 0 ? void 0 : _f.length) && !this.searchBeanModal.districtId && !this.zoneIDsSelected.length && !this.searchBeanModal.zoneId) this.updateCityName(this.placeTest);else if (!this.zoneIDsSelected.length && ((_g = this.searchBeanModal.districtIdList) === null || _g === void 0 ? void 0 : _g.length) === 1) this.updateSingleDistrictName(this.getSingleSelectedDistrict());else if (this.zoneIDsSelected.length === 1 && !((_h = this.searchBeanModal.districtIdList) === null || _h === void 0 ? void 0 : _h.length)) this.updateZoneName(this.getZoneById(this.zoneIDsSelected[0]), 1);else this.updateZoneName(this.placeTest, this.zoneIDsSelected.length + ((_j = this.searchBeanModal.districtIdList) === null || _j === void 0 ? void 0 : _j.length));
        }
      }
    },
    openZoneModal() {
      if (this.zoneList.length + this.localityList.length && (!this.valuation || !this.selling)) this.showZoneModal = true;
    },
    getPlaceFn(query) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!query) return;
        //By default, any input modification will be considered not valid until the selection
        this.isSelectionValid = false;
        this.autocompleteValue = {
          label: query
        };
        this.resetZoneAndLocalities();
        var res = yield getPlace(query, "C,P,Z,L,I,R,A,D");
        return res.map((place, index) => ({
          id: index,
          label: place.displayName,
          payload: place
        }));
      });
    },
    confirmPlace() {
      var _a;
      this.spinnerIcon = true;
      this.updatePlaceName();
      if (this.freesearch) {
        this.search(this.listing, this.customListingTypologyURL, this.useContractType, this.agencyFilter, {
          value: this.freesearchValue
        });
      } else if (this.valuation || this.selling) {
        this.publicValuation.realEstateValuation.address = ((_a = this.tempPlace) === null || _a === void 0 ? void 0 : _a.address) || "";
        this.placeTest = this.tempPlace;
        this.tempPlace = null;
        this.emitPlace();
      } else {
        this.fixSearchBean(() => {
          var _a;
          this.placeTest = this.zoneList.find(plc => plc.zoneID == this.searchBeanModal.zoneId) || this.placeTest;
          return (_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        }, () => {
          var _a;
          this.placeTest = this.localitySelected ? Object.assign({}, this.localitySelected) : this.placeTest;
          return (_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        }, () => {
          var _a;
          return (_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        });
        this.updatePlaceName();
        this.searchBeanModal.polygonFromMap = "";
        this.searchBeanModal.polygonForDB = undefined;
        if (this.listing) {
          this.updateSearchBean(this.searchBeanModal);
          this.search(this.listing, this.customListingTypologyURL, this.useContractType, this.agencyFilter);
        } else {
          this.emitPlace();
          this.dropDownMenu = false;
        }
      }
    },
    openMapDraw() {
      if (this.listing) this.hidePlaceModal();
      this.showMap();
    },
    closeModal() {
      var _a, _b;
      document.body.classList.remove("modal-open");
      (_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.classList.remove("show", "tw-block");
      (_b = this.backdrop) === null || _b === void 0 ? void 0 : _b.classList.add("tw-hidden");
    },
    hidePlaceModal() {
      this.closeModal();
      this.$emit("hide-place-modal", true);
    },
    showMap() {
      this.$emit("show-map", {
        aroundMe: this.aroundMe,
        searchBean: this.searchBeanModal
      });
    },
    emitPlace() {
      /* closes keyboard after sending the place on safari */
      this.updatePlaceName();
      if (this.valuation || this.selling) {
        this.valuationPlace = this.placeTest;
      } else {
        //Ensuring that the place and the searchBeanModal have updated before emitting them
        this.$nextTick(() => {
          this.$emit("emit-place", {
            place: this.placeTest,
            aroundMe: false,
            radius: 0,
            searchBean: deepCopy(this.searchBeanModal),
            polygon: ""
          });
        });
      }
    }
  }, mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"]))
});